import React, { Component } from 'react';

import style from './SocialLinks.module.scss';

const SocialLinks = props => {
  return (
    <ul
      className={`${style.socialLinks} ${
        props.mainNavColor === 'white' ? style.whiteSocial : ''
      } ${props.redIcons ? style.redSocial : ''} `}
    >
      <li className={`${props.noPad ? style.noPad : ''} ${style.socialItem}`}>
        <a
          href={props.data.instagram}
          className={style.instagram}
          target="_blank"
          rel="noopener"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="26"
            viewBox="0 0 26 26"
          >
            <title>Instagram Icon</title>
            <path
              fillRule="evenodd"
              d="M13.021,18.044 C15.79,18.044 18.043,15.791 18.043,13.022 C18.043,10.253 15.79,8 13.021,8 C10.252,8 8,10.253 8,13.022 C8,15.791 10.252,18.044 13.021,18.044 Z M13.021,6 C16.893,6 20.043,9.15 20.043,13.022 C20.043,16.894 16.893,20.044 13.021,20.044 C9.149,20.044 6,16.894 6,13.022 C6,9.15 9.149,6 13.021,6 Z M19.5,0 C23.084,0 26,2.916 26,6.5 L26,19.5 C26,23.084 23.084,26 19.5,26 L6.5,26 C2.916,26 0,23.084 0,19.5 L0,6.5 C0,2.916 2.916,0 6.5,0 L19.5,0 Z M24,19.5 L24,6.5 C24,4.019 21.981,2 19.5,2 L6.5,2 C4.019,2 2,4.019 2,6.5 L2,19.5 C2,21.981 4.019,24 6.5,24 L19.5,24 C21.981,24 24,21.981 24,19.5 Z M20,5 C19.4477153,5 19,4.55228475 19,4 C19,3.44771525 19.4477153,3 20,3 C20.5522847,3 21,3.44771525 21,4 C21,4.55228475 20.5522847,5 20,5 Z"
            />
          </svg>
        </a>
      </li>
      <li className={style.socialItem}>
        <a
          href={props.data.facebook}
          className={style.facebook}
          target="_blank"
          rel="noopener"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 22 22"
          >
            <title>Facebook Icon</title>
            <path
              fillRule="evenodd"
              d="M20.3076923,0 L1.69230769,0 C0.759,0 0,0.759 0,1.69230769 L0,20.3076923 C0,21.241 0.759,22 1.69230769,22 L10.5769231,22 C10.8104615,22 11,21.8104615 11,21.5769231 L11,15.6538462 C11,15.4203077 10.8104615,15.2307692 10.5769231,15.2307692 L8.88461538,15.2307692 C8.65107692,15.2307692 8.46153846,15.0412308 8.46153846,14.8076923 L8.46153846,11.4230769 C8.46153846,11.1895385 8.65107692,11 8.88461538,11 L10.5769231,11 C10.8104615,11 11,10.8104615 11,10.5769231 L11,8.88461538 C11,6.31823077 13.0874615,4.23076923 15.6538462,4.23076923 L18.1923077,4.23076923 C18.4258462,4.23076923 18.6153846,4.42030769 18.6153846,4.65384615 L18.6153846,8.03846154 C18.6153846,8.272 18.4258462,8.46153846 18.1923077,8.46153846 L16.5,8.46153846 C15.8002308,8.46153846 15.2307692,9.031 15.2307692,9.73076923 L15.2307692,10.5769231 C15.2307692,10.8104615 15.4203077,11 15.6538462,11 L18.1923077,11 C18.3141538,11 18.4292308,11.0524615 18.5096154,11.143 C18.59,11.2343846 18.6272308,11.3553846 18.612,11.4755385 L18.1889231,14.8601538 C18.1626923,15.0716923 17.9816154,15.2307692 17.7692308,15.2307692 L15.6538462,15.2307692 C15.4203077,15.2307692 15.2307692,15.4203077 15.2307692,15.6538462 L15.2307692,21.5769231 C15.2307692,21.8104615 15.4203077,22 15.6538462,22 L20.3076923,22 C21.241,22 22,21.241 22,20.3076923 L22,1.69230769 C22,0.759 21.241,0 20.3076923,0"
            />
          </svg>
        </a>
      </li>
      <li className={style.socialItem}>
        <a
          href={props.data.twitter}
          className={style.twitter}
          target="_blank"
          rel="noopener"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="18"
            viewBox="0 0 22 18"
          >
            <title>Twitter Icon</title>
            <path
              fillRule="evenodd"
              d="M21.9063255,2.13692846 C21.7963258,2.01372874 21.6159262,1.98072881 21.4685265,2.05406198 C21.2961936,2.14059512 20.9148611,2.2630615 20.4975954,2.36939459 C20.9207278,1.8831957 21.2741936,1.29506371 21.4149933,0.775864896 C21.4553265,0.626998569 21.39886,0.470065594 21.2741936,0.380599131 C21.1480606,0.291132669 20.9808609,0.290399337 20.8547279,0.376932473 C20.5723952,0.569065368 19.2457982,1.13299741 18.4230001,1.29653037 C17.4014691,0.401132418 16.3887381,0 15.1611409,0 C14.252543,0 13.4084782,0.250066096 12.4250805,0.810331484 C10.6724178,1.8091292 10.4069517,4.00692419 10.5580181,5.29538792 C5.71216246,4.89132217 2.99663532,2.191195 2.03743751,1.021531 C1.96190435,0.929864545 1.84603795,0.877797997 1.72797155,0.88806464 C1.60917182,0.89686462 1.5021054,0.961397806 1.44050554,1.06333091 C0.801040331,2.11492851 0.624307401,3.29485915 0.930840035,4.47478979 C1.12297293,5.21472143 1.48230544,5.86591995 1.88710452,6.37485212 C1.59303852,6.2215858 1.30410585,6.02651958 1.05697308,5.8299867 C0.946973331,5.7419869 0.795907009,5.72658693 0.669773964,5.78672013 C0.542907587,5.84831999 0.462241104,5.9759197 0.462241104,6.11671938 C0.462241104,8.25071451 1.90103782,9.70711118 3.14110166,10.4265095 C2.86756895,10.378843 2.58303626,10.3018432 2.32123686,10.22411 C2.18263718,10.1830434 2.03303752,10.22631 1.93917107,10.3355764 C1.84457128,10.4441095 1.82330466,10.5988425 1.88343786,10.7293755 C2.64316946,12.3676384 4.17876596,13.573969 5.87789541,13.9362349 C4.40976543,14.8528994 2.32710352,15.3104984 0.407974561,15.0926989 C0.236374953,15.0758323 0.0706419976,15.1799654 0.0171087864,15.347165 C-0.0356910931,15.5136313 0.0369087412,15.6947642 0.19090839,15.7790973 C2.42536996,17.0044945 4.74636466,17.5999598 7.2858922,17.5999598 L7.3020255,17.5999598 C10.8792173,17.5970265 14.2085431,16.0672967 16.6754708,13.2938363 C18.9121323,10.7799754 20.076663,7.59291601 19.8192636,4.72338922 C20.4235289,4.2965902 21.3651267,3.47012541 21.9407921,2.58132744 C22.0309919,2.44272776 22.0170586,2.26012818 21.9063255,2.13692846"
            />
          </svg>
        </a>
      </li>
      <li className={style.socialItem}>
        <a
          href={props.data.youtube}
          className={style.youtube}
          target="_blank"
          rel="noopener"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="19"
            viewBox="0 0 26 19"
          >
            <title>YouTube Icon</title>
            <path
              fillRule="evenodd"
              d="M17.9299545,9.86877273 L10.1572273,14.6187727 C10.0881364,14.6610909 10.0104091,14.6818182 9.93181818,14.6818182 C9.85927273,14.6818182 9.78672727,14.6636818 9.72109091,14.6265455 C9.58463636,14.5505455 9.5,14.4063182 9.5,14.25 L9.5,4.75 C9.5,4.59454545 9.58463636,4.45031818 9.72109091,4.37345455 C9.85754545,4.29745455 10.0242273,4.30004545 10.1572273,4.38122727 L17.9299545,9.13122727 C18.0577727,9.20981818 18.1363636,9.34972727 18.1363636,9.5 C18.1363636,9.65113636 18.0577727,9.79018182 17.9299545,9.86877273 M22.3448636,0.589 C21.6902273,0.534590909 21.0545909,0.475863636 20.4241364,0.418 C18.0992273,0.202954545 15.9038636,0 12.9545455,0 C10.1054091,0 7.71572727,0.216772727 5.4055,0.426636364 C4.79577273,0.481909091 4.18518182,0.537181818 3.56422727,0.589 C1.56577273,0.756545455 0,2.45704545 0,4.46240909 L0,14.5384545 C0,16.5429545 1.56577273,18.2443182 3.56422727,18.411 C4.21368182,18.4654091 4.84413636,18.5232727 5.47113636,18.5811364 C7.81331818,18.7961818 10.0259545,19 12.9545455,19 C15.9660455,19 18.1113182,18.7996364 20.3844091,18.5880455 C21.0243636,18.5275909 21.6720909,18.468 22.3448636,18.411 C24.3441818,18.2443182 25.9090909,16.5429545 25.9090909,14.5384545 L25.9090909,4.46240909 C25.9090909,2.45704545 24.3441818,0.756545455 22.3448636,0.589"
            />
          </svg>
        </a>
      </li>
    </ul>
  );
};

export default SocialLinks;



// WEBPACK FOOTER //
// ./src/components/global/SocialLinks.js